'use strict';

var DataTransformerFactory = function DataTransformerFactory() {
  function DataTransformer(sourceType, targetType, priority) {
    this.sourceType = sourceType;
    this.targetType = targetType;
    this.priority = priority || 0;
  }
  DataTransformer.prototype.transform = function () {
    throw new Error('data transformation is not implemented');
  };
  DataTransformer.prototype.canTransform = function () {
    return false;
  };
  DataTransformer.prototype.isCacheable = function () {
    return false;
  };
  DataTransformer.prototype.getCacheKey = function () {
    throw new Error('data transformation is not implemented');
  };
  return DataTransformer;
};
DataTransformerFactory.$inject = [];
module.exports = DataTransformerFactory;